module.exports = __webpack_public_path__ + "assets/img/119d854fc75c7e393873de4678740690.png";